import { useLocalStorage } from "@mantine/hooks";

// Inlined from @/shared-types — PartnerProgram
export interface PartnerProgram {
    name: string;
    displayName?: string;
    type?: string;
}

export const useCustomerProgram = () => {
    const [customerProgram, setCustomerProgram, removeCustomerProgram] = useLocalStorage<PartnerProgram | undefined>({
        key: "customer-program",
        defaultValue: undefined,
    });

    return { customerProgram, setCustomerProgram, removeCustomerProgram };
};
